import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/apiClient";
import { toast } from "sonner";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("admin@booking4u.com");
  const [password, setPassword] = useState("Admin@12345");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back");
      navigate(user.role === "master_admin" ? "/master" : "/dashboard");
    } catch (e) {
      const msg = formatApiErrorDetail(e.response?.data?.detail) || e.message;
      setError(msg); toast.error(msg);
    } finally { setLoading(false); }
  }

  return (
    <div className="min-h-screen flex bg-[#0B101E]" data-testid="login-page">
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
        <img
          src="https://images.pexels.com/photos/32978233/pexels-photo-32978233.jpeg"
          alt=""
          className="w-full h-full object-cover opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0B101E]/60 to-[#0B101E]/90" />
        <div className="relative z-10 p-16 flex flex-col justify-between w-full">
          <Link to="/" className="flex items-center gap-2">
            <span className="w-9 h-9 rounded-md bg-[#D4AF37] flex items-center justify-center text-[#0B101E] font-bold font-display">B</span>
            <span className="font-display text-2xl">Booking4U</span>
          </Link>
          <div>
            <h2 className="font-display text-4xl leading-tight max-w-md">
              "Our ADR improved by <span className="gold-shine">₹800 per night</span> with zero manual effort."
            </h2>
            <div className="mt-6 text-sm text-white/60">Sneha Malhotra — Shoreline Boutique, Goa</div>
          </div>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6 lg:p-16">
        <div className="w-full max-w-md">
          <div className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-4">Welcome back</div>
          <h1 className="font-display text-4xl mb-2">Sign in to Booking4U</h1>
          <p className="text-white/60 text-sm mb-8">Manage your property from one intelligent dashboard.</p>

          <form onSubmit={onSubmit} className="space-y-5">
            <div>
              <label className="text-xs uppercase tracking-widest text-white/50">Email</label>
              <input
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-2 w-full bg-[#12182B] border border-white/10 rounded-md px-4 py-3 focus:outline-none focus:border-[#D4AF37]/60 transition"
                data-testid="login-email-input"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-white/50">Password</label>
              <input
                type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-2 w-full bg-[#12182B] border border-white/10 rounded-md px-4 py-3 focus:outline-none focus:border-[#D4AF37]/60 transition"
                data-testid="login-password-input"
              />
            </div>
            {error && <div className="text-sm text-red-400" data-testid="login-error">{error}</div>}
            <button type="submit" disabled={loading} className="btn-gold w-full rounded-md py-3 disabled:opacity-60" data-testid="login-submit-button">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <div className="mt-8 text-sm text-white/50 text-center">
            New to Booking4U?{" "}
            <Link to="/signup" className="text-[#D4AF37] hover:text-[#F2D06B]" data-testid="link-register">Start free trial</Link>
          </div>
          <div className="mt-3 text-sm text-center">
            <Link to="/forgot-password" className="text-white/50 hover:text-[#D4AF37]" data-testid="link-forgot">Forgot password?</Link>
          </div>
          <div className="mt-10 text-xs text-white/40 bg-[#12182B]/60 border border-white/5 rounded-md p-3">
            Demo · <span className="text-white/60">admin@booking4u.com / Admin@12345</span>
          </div>
        </div>
      </div>
    </div>
  );
}
